import React from "react";

import {
  Dialog,
  DialogContent,
  Divider,
  Grid,
  Slide,
  Typography,
  IconButton
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import PersonIcon from "@mui/icons-material/Person";
import { Close } from "@mui/icons-material";
import { useAppSelector } from "../hooks/reduxhook";
import { getType } from "../redux/slices/typeSlice";
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SharedUser = ({
  open,
  setOpen,
  data,
}: {
  open: boolean;
  setOpen: any;
  data: Array<string>;
}) => {
  const handleClose = () => {
    setOpen();
  };
  const chatType = useAppSelector(getType);
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={"sm"}
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        size="small"
        sx={{
          position: 'absolute',
          right: 2,
          top: 2,

        }}
      >
        <Close sx={{ color: "gray" }} fontSize="small" />
      </IconButton>
      <DialogContent sx={{ p: 4 }}>
        {data.length > 0 ? (
          <>

            <Typography>{chatType.type === 'Image' ? "You have shared this image with:" : chatType.type === "Collections" ? "You have shared this collection with:" : "You have shared this document with:"}</Typography>
            <Divider
              sx={{
                mb: 2,
              }}
            />
            {data.map((d, i) => (
              <Grid container key={i} alignItems="center" ml={1} mb={1}>
                <PersonIcon color="secondary" /> &nbsp;
                <Typography>{d}</Typography>
              </Grid>
            ))}
          </>
        ) : (
          <Typography>You haven&apos;t share this document yet. </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SharedUser;
